import TransactionBadge from 'admin/components/shared/TransactionBadge';
import { formatDate, formatUUID } from 'admin/utils';
import React from 'react';
import CSSModules from 'react-css-modules';
import { Link } from 'react-router-dom';
import { TransactionState } from '~/javascripts/admin/reducers/transaction';
import Table from '../../../atoms/Table';
import styles from './styles.scss';

type Transaction = TransactionState['transactionsV2']['rows'];

type Header = {
  label: React.ReactNode;
  size: number;
  align?: 'center' | 'justify' | 'left' | 'right';
};

const HEADERS: Header[] = [
  { label: '取引種別', size: 1 },
  { label: '取引ID', size: 1 },
  { label: '日時', size: 2 },
  { label: '店舗名（組織名）', size: 6 },
  { label: '端末ID', size: 1 },
  { label: '総額', size: 1, align: 'right' },
];

const UserTransactions = ({ transactions }: { transactions: Transaction }) => (
  <Table styles={{ marginTop: '20px' }}>
    <Table.Header>
      <Table.Row>
        {HEADERS.map((h) => (
          <Table.Cell size={h.size} align={h.align}>
            {h.label}
          </Table.Cell>
        ))}
      </Table.Row>
    </Table.Header>
    <Table.Body>
      {transactions?.map((row) => (
        <Table.Row key={row.id}>
          <Table.Cell wordBreak="keep-all">
            <TransactionBadge transaction={row} styleName="badge" className="" />
          </Table.Cell>
          <Table.Cell wordBreak="keep-all">
            <Link to={`/transactions/${row.id}`}>{formatUUID(row.id)}</Link>
          </Table.Cell>
          <Table.Cell>{formatDate(row.done_at)}</Table.Cell>
          <Table.Cell wordBreak="break-word">
            {`${row.shop_name || '無名の店舗'} (${row.organization_name})`}
          </Table.Cell>
          <Table.Cell wordBreak="keep-all">{formatUUID(row.terminal_id)}</Table.Cell>
          <Table.Cell wordBreak="keep-all" align="right">
            ¥{(row.money_amount + row.raw_point_amount).toLocaleString()}
          </Table.Cell>
        </Table.Row>
      ))}
    </Table.Body>
  </Table>
);

export default CSSModules(UserTransactions, styles);
